module.exports = __webpack_public_path__ + "static/media/services-bg-4.96d97dbd.avif";